// extracted by mini-css-extract-plugin
export var root = "EjF6";
export var rootButton = "_3pZw";
export var rootDescription = "_2W-L";
export var rootHeading = "u+Ua";